import getters from "@/store/modules/poll/getters";
import mutations from "@/store/modules/poll/mutations";
import actions from "@/store/modules/poll/actions";

const state = {
    poll: null,
    pollTime: 0
};

export type State = typeof state;

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};